import { render, staticRenderFns } from "./select-consultor.vue?vue&type=template&id=4ead2fa6"
import script from "./select-consultor.vue?vue&type=script&lang=ts"
export * from "./select-consultor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports